import * as yup from "yup";

export const applicationTypeSeasonSchema = yup.object({
    typeId: yup
        .number()
        .required("Απαιτείται είδος αίτησης"),

    seasonId: yup
        .number()
        .required("Απαιτείται περίοδος"),

    limit: yup
        .string()
        .required("Απαιτείται όριο"),

    amount: yup
        .string()
        .required("Απαιτείται ποσό"),

    diasCode: yup
        .string()
        .required("Απαιτείται Αρ.Πληρωμής ΔΙΑΣ"),

    diasDataKey: yup
        .string()
        .required("Απαιτείται Κωδικοποίηση ΔΙΑΣ"),

    dateFrom: yup
        .mixed()
        .required("Απαιτείται ημερομηνία έναρξης"),

    dateTo: yup
        .mixed()
        .required("Απαιτείται ημερομηνία λήξης"),

    paused: yup.boolean().optional(),
});
